module.exports = __webpack_public_path__ + "static/media/swarm-animated.9b65c22a.webp";